import type { ResolvedComponent } from '@inertiajs/react';
import { Button } from '@/components/ui/Button';
import { PageHeader } from '@/components/ui/PageHeader';
import { RevealOnScroll } from '@/components/ui/RevealOnScroll';
import { trackUmamiEvent } from '@/lib/analytics';

const wrap = 'mx-auto max-w-[1120px] px-5 md:px-10';
const sectionClassName = 'border-line border-t py-[52px] md:py-20';

const AboutUs: ResolvedComponent = () => (
  <>
    <div className={wrap}>
      <PageHeader
        eyebrow="About"
        spark
        title={
          <>
            A personal touch, <em>by Daniela</em>.
          </>
        }
      />
    </div>

    {/* Mission — the legacy site's four mission paragraphs, verbatim
        (typos fixed: through→thorough, Wether→Whether). */}
    <RevealOnScroll>
      <section className="pt-7 pb-[52px] md:pb-20">
        <div className={wrap}>
          <div className="prose">
            <p>
              At PureTouch by Daniela, we believe a clean home is a happy home. Our mission is
              simple: to give you more time to enjoy life while we take care of the cleaning. With a
              team of trusted, detail-oriented professionals, we provide reliable and thorough house
              cleaning services tailored to your needs.
            </p>
            <p>
              We treat every home as if it were our own — using safe, high-quality products and
              proven techniques to leave your space spotless, fresh and inviting. Whether it's
              routine maintenance, deep cleaning, or a move-in/move-out service, we're here to make
              your life easier.
            </p>
            <p>
              More than just cleaners, we're your partners in creating a comfortable, healthy living
              environment. Our commitment to excellence, reliability, and customer satisfaction has
              earned us the trust of families across Toronto.
            </p>
            <p>Let us handle the mess, so you can focus on what matters most.</p>
          </div>
        </div>
      </section>
    </RevealOnScroll>

    {/* Closing CTA */}
    <RevealOnScroll>
      <section className={sectionClassName}>
        <div className={wrap}>
          <h2 className="t-h2 [&_em]:text-primary-deep mb-6 [&_em]:italic">
            Let's look after <em>your</em> space.
          </h2>
          <Button
            variant="solid"
            as="link"
            href="/contact"
            onClick={() => trackUmamiEvent('cta_request_visit', { location: 'about' })}
          >
            Request a visit
          </Button>
        </div>
      </section>
    </RevealOnScroll>
  </>
);

export default AboutUs;
